export default [
    {
      name: 'ManageTrackingNumberHistories',
      title: 'Manage Tracking Number Histories',
      icon: 'mdi-axis',
    }
]
